// @flow

import styled from 'styled-components';

export default styled.div`
  padding: 12rem 0 0;
  color: #fff;
  text-align: center;
  
  &.rtl {
    > .profileDetailsWrapper {
       > .profileDetails {
         text-align: right;
         > div > p {
          float: right;
          margin: 0 0 0 4rem;
          > span {
            float: left;
          }
         }
       }
       > .section {
         text-align: right;
         > .textWrapper {
           float: right;
         }
       }
    }
    .actionButton {
      float: left;
    }
  }
  
  > .profileDetailsWrapper {
    width: 60rem;
    margin: 0 auto;
    > .profileDetails {
      text-align: left;
      > h1 {
        font-size: 2rem;
        margin-bottom: 2rem;
      }
      > div {
        margin-bottom: 7rem;
        > p {
          font-size: 1.2rem;
          float: left;
          margin: 0 4rem 0 0;
          > span {
            color: #a1a1a1;
            margin: 0 .5rem;
            float: right;
          }
        }
      }
    }
    > .section {
      overflow: hidden;
      border-radius: 0.7rem;
      display: inline-block;
      background: rgba(255, 255, 255, 0.07);
      margin-bottom: .8rem;
      width: 100%;
      padding: 1.5rem 2rem;
      box-sizing: border-box;
      text-align: left;
      > .textWrapper {
        float: left;
        .sectionTitle {
          line-height: 2.5rem;
          font-size: 1.2rem;
          margin: -.4rem 0 0 0;
          white-space: nowrap;
        }
        .sectionDescription {
          font-size: 1rem;
          color: #a1a1a1;
          margin: .5rem 0 0;
          line-height: 1;
        }
        &.logout {
          margin-top: 1rem;
        }
      }
    }
  }
  .actionButton {
    text-align: center;
    min-width: 10rem;
    float: right;
    background: rgba(255,255,255,.4);
    margin: .5rem auto 0;
    padding: .4rem 1rem;
    color: #fff;
    outline: none;
    border: .4rem solid transparent;
    border-radius: .5rem;
    cursor: pointer;
    box-sizing: border-box;
    font-size: 1.2rem;
    &.activeItem, &:hover {
      background: #fff;
      color: #020100;
      border: .4rem solid #ea1d5d;
    }
  }
  .version {
    position: fixed;
    bottom: .5rem;
    left: 0;
    right: 0;
    font-size: 1rem;
    color: #4f4f4f;
    text-align: center;
  }

  .about_phrase {
    display: inline-block;
    width: 100%;
    margin-top: 20px;
    color: #a1a1a1;
  }
`;
